import {Component, inject, OnInit} from '@angular/core';
import {ButtonComponent} from "../../../shared/components/button/button.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TextInputComponent} from "../../../shared/inputs/text-input/text-input.component";
import {BaseComponent} from "../../../shared/base/base-component";
import {ApiService} from "../../../core/api/api.service";
import {State} from "../../../shared/base/base-state";
import {type AdminForgotPasswordRequest, AdminForgotPasswordResponse} from "../../../core/api/model";

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    TextInputComponent
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit {

  formBuilder = inject(FormBuilder);
  apiService = inject(ApiService);

  forgotPasswordState = new State<AdminForgotPasswordResponse>();

  forgotPasswordForm!: FormGroup;

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onForgotPasswordClicked() {
    let request: AdminForgotPasswordRequest = {
      email: this.forgotPasswordForm.controls['email'].value,
    }
    this.executeRequest({
      state: this.forgotPasswordState,
      request: this.apiService.resetAdminPasswordRequest(request),
      onSuccess: (response) => {
        this.router.navigate(["/login"]);
      },
      handleSuccess: true,
      successMessage:
        "We will send you the reset password link to entered email.",
    });
  }

  onLoginClicked() {
    this.router.navigate(["/login"]);
  }
}
